// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c361dbb8","455":"68049db2","977":"bd5673c0"}[chunkId] + ".chunk.js";
};